/**
 * Enum containing the keys/names of name spaces files containing i18n data
 */
export enum TranslationNS {
  CompanyInfo = 'company-info',
  CompanyAdmin = 'company-admin',
  LeaveManagement = 'leave-management',
  Auth = 'auth',
  Department = 'department',
  Designation = 'designation',
  Employee = 'employee',
  Dashboard = 'dashboard',
  Profile = 'profile',
  PersonalInformation = 'personal-information',
  BankingDetails = 'banking-details',
  AssetDetails = 'asset-details',
  FamilyDetails = 'family-details',
  EducationDetails = 'education-details',
  LeaveTransactions = 'leave-transactions',
  ResetPassword = 'reset-password',
  Documents = 'documents',
  Brand = 'brand',
  LeaveRequestManagement = 'leave-request-management',
  InitialResetPassword = 'initial-reset-password',
  Branch = 'branch',
  AssetType = 'asset-type',
  CompanyAsset = 'company-asset',
  BankDetails = 'bank-details',
  validations = 'validations',
  Files = 'files',
  Notes = 'notes',
  EmployeeAccess = 'employee-access',
  NoAccess = 'no-access',
  ShareDialog = 'share-dialog',
  LibsCommon = 'libsCommon',
  Common = 'common',
  slack = 'slack',
  teams = 'teams',
  chatbot = 'chatbot',
  Benefits = 'benefits',
  Filters = 'filters',
  Announcements = 'announcements',
  Announcement = 'announcement',
  TaskLists = 'task-lists',
  EmployeeBoarding = 'employee-boarding',
  Timesheet = 'timesheet',
  Sidebar = 'sidebar',
  Organization = 'organization',
  Reminders = 'reminders',
  ReleaseNotes = 'release-notes',
  Tour = 'tour',
  TaskManagement = 'task-management',
  AdminTasks = 'admin-tasks',
  EmployeeTasks = 'employee-tasks',
  Onboarding = 'onboarding',
  Survey = 'survey',
  CompanyActivity = 'company-activity',
  AdminActivity = 'admin-activity',
  McpConsent = 'mcp-consent',
  Integrations = 'integrations',
  Notification = 'notification',
  TwoFactor = 'two-factor',
  Sso = 'sso',
  Performance = 'performance',
  Recruiting = 'recruiting',
  Readiness = 'readiness',
  MyTeam = 'my-team',
  Billing = 'billing',
  Esignature = 'esignature',
  SignatureRequests = 'signature-requests',
  Analytics = 'analytics',
  Training = 'training',
  PayrollExport = 'payroll-export',
}
export enum TranslationNS_Admin {
  Auth = 'auth',
  AdminUser = 'admin-user',
  CompanyInfo = 'company-info',
  UserExplorer = 'user-explorer',
  Profile = 'profile',
  SystemSettings = 'system-settings',
  Dashboard = 'dashboard',
  Billing = 'billing',
  ScanReports = 'scan-reports',
  ProductMetrics = 'product-metrics',
}
